export enum ColumnsOptionsCanceledOrdersEnum {
	tickerCompany = 'tickerCompany',
	operation = 'operation',
	quantity = 'quantity',
	price = 'price',
	term = 'term',
	orderType = 'orderType',
	executed = 'executed',
	statusTitle = 'statusTitle',
}
